import React, { createContext, useState, useEffect } from 'react';
import UserPool from './UserPool';
import { useHistory } from 'react-router-dom';

export const AccountContext = createContext();

export const AccountProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const history = useHistory();

  useEffect(() => {
    checkAuthentication();
  }, []);

  const fetchUserAttributes = (cognitoUser) => {
    return new Promise((resolve, reject) => {
      if (!cognitoUser) return resolve(null);
      cognitoUser.getUserAttributes((err, attributes) => {
        if (err) return resolve(null);
        const attrMap = {};
        attributes.forEach(attr => {
          attrMap[attr.getName()] = attr.getValue();
        });
        resolve(attrMap);
      });
    });
  };

  const checkAuthentication = () => {
    const cognitoUser = UserPool.getCurrentUser();
    if (cognitoUser) {
      cognitoUser.getSession(async (err, session) => {
        if (err) {
          setIsAuthenticated(false);
          setUser(null);
        } else {
          setIsAuthenticated(session.isValid());
          if (session.isValid()) {
            const attributes = await fetchUserAttributes(cognitoUser);
            setUser(attributes);
          } else {
            setUser(null);
          }
        }
      });
    } else {
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  const logout = () => {
    const user = UserPool.getCurrentUser();
    if (user) {
      user.signOut();
    }
    
    // Clear tokens from localStorage
    window.localStorage.removeItem('idToken');
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('refreshToken');
    
    // Update authentication state
    setIsAuthenticated(false);
    setUser(null);
    
    // Redirect to login page
    if (history) {
      history.push('/login');
    } else {
      window.location.href = '/login';
    }
  };

  return (
    <AccountContext.Provider value={{ 
      isAuthenticated, 
      setIsAuthenticated,
      user,
      setUser,
      checkAuthentication,
      logout
    }}>
      {children}
    </AccountContext.Provider>
  );
};
